import NewAggregation from './newAggregation'
export default NewAggregation
